import { UseMutationOptions } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type UseEnableTriggerMutationArgs = {
  triggerUid: string;
};

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    UseEnableTriggerMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const enableTrigger = ({ triggerUid }: UseEnableTriggerMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/triggers/${triggerUid}/enable`,
  );
};

const useEnableTriggerMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationFn: enableTrigger,
    ...options,
  });
};

export default useEnableTriggerMutation;
